(function(){
  function init(){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
    var nav = document.querySelector('.dna-nav');
    if(nav){
      window.addEventListener('scroll', function(){
        nav.classList.toggle('solid', window.scrollY > 40);
      });
    }
  }
  if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
